function copyObject(proto, to_copy, exclude = []) {
    let keys = Object.keys(proto);
    for (let k of keys) {
        if (exclude.includes(k)) continue;
        console.log(k, proto[k], to_copy[k]);
        if (proto[k] !== undefined) {
            console.log("->", k, proto[k], to_copy[k]);
            if (Array.isArray(proto[k]) || typeof proto[k] == "object") {
                proto[k] = JSON.parse(JSON.stringify(to_copy[k]));
                continue;
            }
            if (to_copy[k] !== undefined) proto[k] = to_copy[k];
        }
    }
}

export default copyObject;
